import { jsxs, jsx } from 'react/jsx-runtime';
import { Skeleton } from '../ui/skeleton.js';
import { cn } from '../../lib/utils.js';

const SkeletonDefault = ({
  col = 2,
  row = 1,
  gap = 2,
  border = "all",
  className,
  img
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: cn(
        "w-full flex justify-start text-left gap-2 [&+&]:mt-2 bg-base-white",
        border === "all" && "p-5 border border-basic-05 rounded-[12px]",
        border === "y" && "py-5 border-b first:border-t first:border-basic-05 border-basic-05 ",
        className
      ),
      children: [
        img && /* @__PURE__ */ jsx(Skeleton, { className: "w-10 h-10 rounded-lg flex-[0_0_40px]" }),
        /* @__PURE__ */ jsx("div", { className: cn("flex w-full", `gap-${gap}`), children: Array.from({ length: row }, (_, idx) => {
          return /* @__PURE__ */ jsx(
            "div",
            {
              className: cn(
                "w-full flex flex-col text-left gap-2",
                row > 1 && idx === 0 ? "w-[30%]" : "flex-1"
              ),
              children: Array.from({ length: col }, (_2, idx2) => {
                return /* @__PURE__ */ jsx(
                  Skeleton,
                  {
                    className: cn("w-full h-4")
                  },
                  `skeleton_${idx2}`
                );
              })
            },
            idx
          );
        }) })
      ]
    }
  );
};

export { SkeletonDefault };
